import React from "react";
import MiniSpinner from "../common/MiniSpinner";

class CommonSymptoms extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { symptoms, isSymptomsWaiting } = this.props;
        const conditions = symptoms && symptoms.conditions ? symptoms.conditions.treatableConditions : null;
        const conditionsSplit = conditions ? ((conditions.length / 3) + 1) : 0;
        return (
            <div className="row common-symptoms-container">
                <div className="col-12 maxWidth-content">
                    <div className="svg-conditions" />
                    <div className="modal-heading">On-Call Provider</div>
                    <div className="symptoms-heading">Common symptoms treated:</div>
                </div>
                {!isSymptomsWaiting && conditions && conditions.length > 0 &&
                    <React.Fragment>
                        <div className="col-12">
                            <ul className="angle-bullets">
                                {conditions.map((condition, index) => {
                                    return (
                                        <li key={index}>{condition.conditionName}</li>
                                    );
                                })}
                                <li key="note">Labs, x-rays, referrals not available</li>
                            </ul>
                        </div>
                        {/*<div className="col-12 col-md-4">
                            <ul className="angle-bullets">
                            {conditions.slice(0, conditionsSplit).map((condition, index) => {
                                    return (
                                        <li key={index}>{condition.conditionName}</li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="col-12 col-md-4">
                            <ul className="angle-bullets">
                            {conditions.slice(conditionsSplit, conditionsSplit *2 - 1).map((condition, index) => {
                                    return (
                                        <li key={index}>{condition.conditionName}</li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="col-12 col-md-4">
                            <ul className="angle-bullets">
                            {conditions.slice(conditionsSplit *2 - 1, conditionsSplit.length).map((condition, index) => {
                                    return (
                                        <li key={index}>{condition.conditionName}</li>
                                    );
                                })}
                            </ul>
                        </div>*/}
                    </React.Fragment>
                }
                {isSymptomsWaiting && <div className="col-12 text-center"><MiniSpinner /></div>}
            </div>
        )
    }
}

export default CommonSymptoms;